import { engeniApi } from '@/api/engeni.api';
import type { ApiResponseData } from '@/interfaces/api.interface';
import type {
  TiendanubeAuthorizationStateResponse,
  TiendanubePendingInstallation,
  TiendanubeReleaseResponse,
  TiendanubeBindResponse,
  TiendanubeConnectResponse,
  TiendanubeInstallationResponse,
} from './installation.interface';

const BASE_PATH = '/flok';
const BASE_PUBLIC_PATH = `/public${BASE_PATH}`;

export const installationApi = {
  // The Tiendanube app installation is Flokee's, like every provider's. FLOK-1726.
  async createTiendanubeAuthorizationState(ecommerce_id?: number) {
    return await engeniApi.post<ApiResponseData<TiendanubeAuthorizationStateResponse>>(
      `${BASE_PATH}/tiendanube/authorization-state`,
      { ecommerce_id },
    );
  },
  async createTiendanubeInstallation(code: string, state?: string) {
    return await engeniApi.post<ApiResponseData<TiendanubeInstallationResponse>>(
      `${BASE_PUBLIC_PATH}/tiendanube/installations`,
      { code, state },
    );
  },
  async bindTiendanubeInstallation(
    installation_token: string,
    account_id: number,
    plan_id: number,
    offer_id?: number,
  ) {
    return await engeniApi.post<ApiResponseData<TiendanubeBindResponse>>(
      `${BASE_PATH}/tiendanube/installations/bind`,
      { installation_token, account_id, plan_id, offer_id },
    );
  },
  async getPendingTiendanubeInstallations() {
    return await engeniApi.get<ApiResponseData<TiendanubePendingInstallation[]>>(
      `${BASE_PATH}/tiendanube/installations/pending`,
    );
  },
  async releaseTiendanubeInstallation(operation_key: string, account_id: number) {
    return await engeniApi.post<ApiResponseData<TiendanubeReleaseResponse>>(
      `${BASE_PATH}/tiendanube/installations/release`,
      { operation_key, account_id, confirm_order_unchanged: true },
    );
  },
  // Connects the store to the ecommerce named, never to whatever is current.
  async completeTiendanubeInstallation(installation_token: string, ecommerce_id: number) {
    return await engeniApi.post<ApiResponseData<TiendanubeConnectResponse>>(
      `${BASE_PATH}/tiendanube/installations/complete`,
      { installation_token, ecommerce_id },
    );
  },
};
